import { DatePicker } from 'antd';
import React from 'react';
const { RangePicker } = DatePicker;

export const LCRangePicker = props => <RangePicker {...props} />;
